/** Allowed EventBridge custom bus ARN shape for this pond integration */
export const EVENT_BUS_ARN_REGEX =
  /^arn:aws:events:[a-z0-9-]+:\d{12}:event-bus\/[A-Za-z0-9._-]+$/;

export function isValidEventBusArn(arn: string): boolean {
  return EVENT_BUS_ARN_REGEX.test(arn.trim());
}
